

import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import FrontSide from './FrontSide';
import BackSide from './BackSide';
import { connect } from 'react-redux';
import { setSide, hideCanvasBoeder } from '../actions';
import logo from '../Logos/wwl-logo.svg';
import { ReactSVG } from 'react-svg';
import { AddToChart } from './AddToChart';
import {
  FABRIC_LOGICAL_WIDTH,
  FABRIC_LOGICAL_HEIGHT,
  CANVAS_CSS_SCALE_EVENT,
} from '../canvasConstants';



const Spinner = () => {
  return( <ReactSVG src={logo} className='spinner' />);
};

/** Padding inside .engravingBody so the scaled canvas does not touch edges / scrollbars */
const FIT_PADDING_PX = 12;

const FIT_RETRY_MAX = 40;

class Engraving extends Component {
  constructor(props) {
    super(props);
    this.engravingBodyRef = React.createRef();
    this.bodyResizeObserver = null;
    this._windowResizeTimer = null;
    this._onWindowResize = this._onWindowResize.bind(this);
    this._fitRetryCount = 0;
    /** Avoid ResizeObserver ↔ Fabric resize loops and redundant re-renders */
    this._lastAppliedFitScale = null;
  }

  state = { open: false ,
    hasBackside: false,
    userImages: [],
    loading: false ,
  };

  resizeCanvasFit() {
    const el = this.engravingBodyRef.current;
    if (!el) return;
    const pad = FIT_PADDING_PX * 2;
    /* Use layout box from the viewport — clientWidth/Height can disagree with what’s actually visible in nested flex. */
    const bodyRect = el.getBoundingClientRect();
    const col = el.closest('.engraving');
    const colRect = col ? col.getBoundingClientRect() : bodyRect;
    const w = Math.max(0, Math.floor(Math.min(bodyRect.width, colRect.width)) - pad);
    const h = Math.max(0, Math.floor(Math.min(bodyRect.height, colRect.height)) - pad);
    /* Flex layout often reports 0×0 on first frames — retry before skipping scale (else Fabric never gets cssOnly sizes). */
    if (w < 2 || h < 2) {
      if (this._fitRetryCount < FIT_RETRY_MAX) {
        this._fitRetryCount += 1;
        requestAnimationFrame(() => this.resizeCanvasFit());
      } else {
        this._fitRetryCount = 0;
        /* Never force scale=1 — that overflows narrow columns (red frame looks like an “L” clipped on the right/bottom). */
        const vw = typeof window !== 'undefined' ? window.innerWidth : FABRIC_LOGICAL_WIDTH;
        const vh = typeof window !== 'undefined' ? window.innerHeight : FABRIC_LOGICAL_HEIGHT;
        const guess = Math.min((vw * 0.5) / FABRIC_LOGICAL_WIDTH, (vh * 0.45) / FABRIC_LOGICAL_HEIGHT, 0.95);
        const scale = Math.max(0.2, Math.min(guess, 1));
        this._applyFitScaleIfChanged(el, scale);
      }
      return;
    }
    this._fitRetryCount = 0;
    const s = Math.min(w / FABRIC_LOGICAL_WIDTH, h / FABRIC_LOGICAL_HEIGHT, 1);
    this._applyFitScaleIfChanged(el, s);
  }

  _applyFitScaleIfChanged(el, scale) {
    const prev = this._lastAppliedFitScale;
    if (prev !== null && Math.abs(scale - prev) < 0.0005) return;
    this._lastAppliedFitScale = scale;
    el.style.setProperty('--engrave-canvas-scale', String(scale));
    window.dispatchEvent(new CustomEvent(CANVAS_CSS_SCALE_EVENT, { detail: { scale } }));
    /* Do not dispatch window "resize" here — it re-enters _onWindowResize and fights ResizeObserver, causing flicker. */
  }

  _onWindowResize() {
    clearTimeout(this._windowResizeTimer);
    this._windowResizeTimer = setTimeout(() => {
      window.requestAnimationFrame(() => this.resizeCanvasFit());
    }, 80);
  }

  componentDidMount() {
    if (this.props.back_image) {
      this.setState({ hasBackside : true });
    }
    const el = this.engravingBodyRef.current;
    if (el && typeof ResizeObserver !== 'undefined') {
      this.bodyResizeObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(() => this.resizeCanvasFit());
      });
      this.bodyResizeObserver.observe(el);
    }
    if (el) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => this.resizeCanvasFit());
      });
    }
    window.addEventListener('resize', this._onWindowResize);
    window.addEventListener('orientationchange', this._onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('orientationchange', this._onWindowResize);
    clearTimeout(this._windowResizeTimer);
    if (this.bodyResizeObserver) {
      this.bodyResizeObserver.disconnect();
      this.bodyResizeObserver = null;
    }
  }


  render() {
    let totalPrice;
    if (this.props.countFS > 0 && this.props.countBS > 0 ) {
      totalPrice = parseFloat(this.props.product.price) + parseFloat(this.props.product.front_side_price) +  parseFloat(this.props.product.back_side_price);
    } else if (this.props.countFS > 0 ) {
      totalPrice = parseFloat(this.props.product.price) + parseFloat(this.props.product.front_side_price);
    } else if (this.props.countBS > 0 ) {
      totalPrice = parseFloat(this.props.product.price) + parseFloat(this.props.product.back_side_price);
    } else totalPrice = parseFloat(this.props.product.price);
    let euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

    return(
      <div className='engravingWrapper'>
        <div className='engravingHeader'>
          <div className='engravingArea'>
          Gravurbereich: {this.props.sideIs === 'front'? `${this.props.product.workArea.front.workAreaWidth} x ${this.props.product.workArea.front.workAreaHeight} cm` : `${this.props.product.workArea.back.workAreaWidth} x ${this.props.product.workArea.back.workAreaHeight} cm` }
          </div>
          <div
            className={this.props.sideIs === 'front'? 'selected' : 'divAsButton' }
            onClick={() => this.props.setSide('front')} >{this.props.product.front_variant_label || 'VARIANTE 1'}</div>
          <div
            className={ this.state.hasBackside ?
              this.props.sideIs !== 'front'? 'selected' : 'divAsButton' : 'disabled'
            }
            onClick={this.state.hasBackside? () => this.props.setSide('back') : null} >{this.props.product.back_variant_label || 'VARIANTE 2'}</div>
        </div>
        <div className='engravingBody' ref={this.engravingBodyRef}>

          <Popup
            contentStyle={{ background: '#4e4e4e', border: 'none' }}
            open={this.state.loading}
            closeOnDocumentClick={false}
          >
            <div>
              <div style={{ textAlign: 'center' }}>Ihre Bestellung wird bearbeitet</div>
              <Spinner />
            </div>
          </Popup>
          <FrontSide  />
          <BackSide   />
        </div>
        <div className='engravingFooter'>
          <div className='wagenButton'>
            <div className='priceBox'>
              <table>
                <tbody>
                  <tr>
                    <td>Produktpreis: </td><td className='price'>{euro.format(this.props.product.price)}</td>
                  </tr>
                  <tr>
                    <td>Gravur Variante 1: </td><td className='price'>{  this.props.product.front_side_price > 0 ? euro.format(this.props.product.front_side_price) : ''   }</td>
                  </tr>
                  {this.state.hasBackside ?
                    <tr>
                      <td>Gravur Variante 2: </td><td className='price'>{ this.props.product.back_side_price > 0 ? euro.format(this.props.product.back_side_price) : '' }</td>
                    </tr> : null }
                  <tr>
                    <td colSpan='2'>inkl. 19% MwSt. zzgl. <a rel='noreferrer' target='_blank' href='https://www.welovelaser.de/versand/'> Versandkosten </a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <button className='buttonToChart'  onClick={() => {
            this.setState({ loading: true });
            AddToChart(this.state, this.props, totalPrice);
          }}>
               IN DEN WARENKORB {euro.format(totalPrice)}
            {/* NaN should show error */}
          </button>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  setSide: side => dispatch(setSide(side)),
  hideCanvasBoeder: border => dispatch(hideCanvasBoeder(border)),
});

const mapStateToProps = state => {
  // orginal pics without manipulate pixels
  const { sideIs, orginalPics } = state.optionsReducer;
  const { frontCurrent, backCurrent } = state.currentFigureReducer;
  const { back_image, authtoken } = state.productReducer.product;
  const { product } = state.productReducer;
  const { countFS } = state.frontsideReducer;
  const { countBS } = state.backsideReducer;
  return {
    sideIs, back_image, frontCurrent, backCurrent, orginalPics, authtoken, product, countFS, countBS
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Engraving);
